module.exports = __webpack_public_path__ + "img/icon-mobile-phone.20d909fe.svg";